import styled from 'styled-components';

export const FileUpload = styled.input`
  width: 0.1px;
  height: 0.1px;
  opacity: 0;
  overflow: hidden;
  position: absolute;
  z-index: -1;

  @media screen and (max-width: 992px) {
    font-size: 16px;
  }
  @media screen and (min-width: 1024px) and (max-width: 1400px) {
    font-size: 20px;
  }
`;
